<template>
  <div class="company">
    <p>Trusted by some of the leading Agri brands</p>
    <div class="logo">
      <img src="../../../assets/brandLogos/mahindra.svg" alt="" />
      <img src="../../../assets/brandLogos/sonalika.svg" alt="" />
      <img src="../../../assets/brandLogos/corteva.svg" alt="" />
      <img src="../../../assets/brandLogos/carnot.svg" alt="" />
      <img src="../../../assets/brandLogos/escorts.svg" alt="" />
      <img src="../../../assets/brandLogos/efeed.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "trustedByCompanies",
};
</script>

<style lang="scss" scoped>
.company {
  padding-top: 50px;
  color: #ababab;
  font-weight: 400;
  font-size: 20px;
  text-align: center;
  margin: auto;
  width: 80%;
  @media all and (max-width : 1024px) {
    font-size: 14px;
  color: #757575;
  p{
    margin-bottom: 32px;
  }

  }
  
}
.logo {
  display: flex;
  justify-content: space-around;
  overflow-x: scroll;
  @media all and (max-width : 1024px) {
    
    img{
      background: #FFFF;
      height:44px;
      width:44px;
    }
  }
}
</style>
